import createGraphqlClient from "@/utils/apollo";

export const fragments = {
	UserRole: `
		fragment UserRole on CmlinkUserRolePagination {
            total
			current_page
			data{
				id 
				name
				can_update
            	can_delete
				permissions
				titles{
					id 
					name
					department {
						name
					}
				}
			}
		}
	`
};

export default createGraphqlClient("cmlink");
